import { withTheme } from 'emotion-theming'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import { withTranslation } from 'server/i18n'
import ContactMap from 'components/ContactMap'

import style from './ContactHero.style'

const ContactHeroStyled = styled.div(props => ({ ...style(props) }))

const ContactHero = ({ t }) => {
    return (
        <ContactHeroStyled>
            <div className="Contact-hero" />
            <div className="Contact-hero--mobile" />
            <ContactMap />
        </ContactHeroStyled>
    )
}

ContactHero.propTypes = {
    t: PropTypes.func.isRequired
}
export default withTranslation('common')(withTheme(ContactHero))
